import { createI18n } from 'vue-i18n'
// import { storeToRefs } from 'pinia'
import vZh from 'view-ui-plus/dist/locale/zh-CN'
import vEn from 'view-ui-plus/dist/locale/en-US'
// import {registerStore} from '@/store'
import EN from './lang/en'
import ZH from './lang/zh'
// const { activeMenu } = storeToRefs(appStore.useMenu)
const messages = {
  en: {
    ...EN,
    ...vEn
  },
  zh: {
    ...ZH,
    ...vZh
  }
}
// const getCurrentLanguage = () => {
//   // 设置
//   // const UAlang = navigator.language // zh-CN
//   // const langCode = UAlang.indexOf('zh') !== -1 ? 'en' : 'zh'
//   localStorage.getItem('lang')
//   return langCode
// }

const i18n = createI18n({
  legacy: false,
  // globalInjection: true,
  locale: localStorage.getItem('lang') || 'en', // 去getCurrentLanguage函数找有没有设置的语言,默认选择zh
  default: 'zh-CN',
  messages
})
export default i18n
